import React, { useEffect } from "react";
import { Box, Grow } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  resetClubNameFilter,
  resetLeagueFilter,
  resetStarRatingFilter,
  resetTargetStarRatingFilter,
} from "../../redux/reducers/common";
import { colors } from "../../common/pallette/colors";
import FiltersWrapper from "./filters/filtersWrapper";

interface HomeFilterPanelProps {
  isOpen: boolean;
  onClose: () => void;
}

const HomeFilterPanel = ({ isOpen, onClose }: HomeFilterPanelProps) => {
  const dispatch = useDispatch();
  const globalFiltersCount = useSelector(
    (state: any) => state.common.globalFiltersCount
  );

  const clearAll = () => {
    dispatch(resetClubNameFilter());
    dispatch(resetLeagueFilter());
    dispatch(resetStarRatingFilter());
    dispatch(resetTargetStarRatingFilter());
  };

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    if (isOpen) document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [isOpen, onClose]);

  return (
    /* Absolute wrapper — zero layout footprint, anchors to SearchFilterAnchor */
    <Box
      sx={{
        position: "absolute",
        top: "100%",
        left: 0,
        zIndex: 1300,
        pt: "6px",
        // Don't trap pointer events when hidden
        pointerEvents: isOpen ? "auto" : "none",
      }}
    >
      <Grow in={isOpen} timeout={180} unmountOnExit>
        <Box
          sx={{
            borderRadius: "8px",
            border: `1px solid ${colors.grey.light}`,
            borderTop: `2px solid ${colors.blue.navy}`,
            backgroundColor: "#fff",
            boxShadow: "0 8px 24px rgba(0,0,0,0.14)",
            px: 2,
            py: 1.5,
            minWidth: "max-content",
          }}
        >
          <FiltersWrapper
            globalFiltersCount={globalFiltersCount}
            onClearAll={clearAll}
            onClose={onClose}
          />
        </Box>
      </Grow>
    </Box>
  );
};

export default HomeFilterPanel;
